import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("ll_token");
        const cached = localStorage.getItem("ll_user");
        if (token && cached) {
            try { setUser(JSON.parse(cached)); } catch { /* ignore */ }
            api.get("/auth/me")
                .then(({ data }) => { setUser(data); localStorage.setItem("ll_user", JSON.stringify(data)); })
                .catch(() => logout())
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("ll_token", data.access_token);
        localStorage.setItem("ll_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("ll_token", data.access_token);
        localStorage.setItem("ll_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const setSessionFromExchange = (data) => {
        localStorage.setItem("ll_token", data.access_token);
        localStorage.setItem("ll_user", JSON.stringify(data.user));
        setUser(data.user);
    };

    const logout = () => {
        localStorage.removeItem("ll_token");
        localStorage.removeItem("ll_user");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, register, logout, setSessionFromExchange }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
